import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogThreadCardSeenDropdownContentItem from './VeltCommentDialogThreadCardSeenDropdownContentItem/VeltCommentDialogThreadCardSeenDropdownContentItem';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltCommentDialogThreadCardSeenDropdownContentItems = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-items-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdownContentItems.Item = VeltCommentDialogThreadCardSeenDropdownContentItem;
export default VeltCommentDialogThreadCardSeenDropdownContentItems;
